export default __webpack_public_path__ + "static/media/img_pdf_4_minerals.fb2f6f9b.png";